import React, { useState } from "react";
import { resolveMediaUrl } from "@/lib/mediaUrl";
import PosProductPlaceholder from "@/components/pos/PosProductPlaceholder";
import { itemHasSizes, itemPosPriceLabel } from "@/lib/menuItemSizes";
import { displayItemName, itemNameSecondary } from "@/lib/menuLocale";
import { useCurrency } from "@/hooks/useCurrency";
import { money2 } from "@/lib/format";

export default function PosProductButton({ item, disabled, onAdd }) {
  const { code: currencyCode } = useCurrency();
  const productImg = resolveMediaUrl(item.img || item.image_url);
  const [imgBroken, setImgBroken] = useState(false);
  const showImg = Boolean(productImg) && !imgBroken;

  return (
    <button
      type="button"
      data-testid={`pos-product-${item.code}`}
      onClick={() => onAdd(item)}
      disabled={disabled}
      className="pos-product-card flex flex-col w-full min-h-[72px] h-[72px] text-left overflow-hidden disabled:opacity-60 touch-manipulation"
    >
      <div className="relative w-full h-[28px] flex-shrink-0 overflow-hidden bg-[#FFF8F3]">
        {showImg ? (
          <img
            src={productImg}
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            onError={() => setImgBroken(true)}
          />
        ) : (
          <PosProductPlaceholder code={item.code} compact />
        )}
      </div>
      <div className="flex-1 px-1.5 py-1 flex flex-col justify-center gap-0.5 min-h-0 min-w-0 border-t border-[#F5EBE3]/80 overflow-hidden">
        <div
          className="text-[9.5px] font-extrabold text-brand-brown truncate"
          style={{ lineHeight: "1.2", paddingBottom: 1 }}
          title={[displayItemName(item), itemNameSecondary(item)].filter(Boolean).join(" · ")}
        >
          {displayItemName(item)}
        </div>
        <div className="flex items-baseline justify-between gap-1 min-w-0">
          <div className="text-[10px] font-extrabold font-mono leading-none tabular-nums text-brand-orange shrink-0">
            {itemPosPriceLabel(item)}
            <span className="text-[7px] font-bold opacity-75 ms-0.5">{currencyCode}</span>
          </div>
          <div className="text-[7px] font-mono font-semibold text-brand-brown/40 truncate">
            {itemHasSizes(item) ? "S / M / L" : item.code}
          </div>
        </div>
      </div>
    </button>
  );
}
